import { render } from "./HomePageContact.vue?vue&type=template&id=92405f6a&scoped=true"
const script = {}

import "./HomePageContact.vue?vue&type=style&index=0&id=92405f6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92405f6a"]])

export default __exports__